// import React, { useState } from "react";
// import {
//   Container,
//   Grid,
//   TextField,
//   Button,
//   Paper,
//   Typography,
// } from "@mui/material";
// import { Link } from "react-router-dom";
// import Swal from "sweetalert2";

// function Register() {
//   // State for form fields
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");

//   // Function to handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     // Call API to register user with email and password
//     try {
//       const response = await fetch("http://localhost:8000/api/register", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ email, password }),
//       });
//       const data = await response.json();
//       console.log(data);
//       // Handle registration response
//       if (response.ok) {
//         Swal.fire({
//           icon: "success",
//           title: "Registration Successful!",
//           text: "User registered successfully",
//         });
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Registration Failed",
//           text: data.message,
//         });
//       }
//     } catch (error) {
//       console.error("Error:", error);
//     }
//   };

//   return (
//     <Container maxWidth="xs" sx={{ marginTop: 5 }}>
//       <Paper sx={{ padding: 2 }}>
//         <Grid container spacing={2} justifyContent="center">
//           <Grid item xs={12}>
//             <Typography variant="h4" align="center">
//               Register
//             </Typography>
//           </Grid>
//           <Grid item xs={12}>
//             <form onSubmit={handleSubmit}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <TextField
//                     type="email"
//                     label="Email"
//                     fullWidth
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <TextField
//                     type="password"
//                     label="Password"
//                     fullWidth
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Button type="submit" fullWidth variant="contained">
//                     Register
//                   </Button>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Link to="/login" style={{ textDecoration: "none" }}>
//                     <Button type="primary" fullWidth variant="contained">
//                       Login
//                     </Button>
//                   </Link>
//                 </Grid>
//               </Grid>
//             </form>
//           </Grid>
//         </Grid>
//       </Paper>
//     </Container>
//   );
// }

// export default Register;

// src/pages/Auth/Register.js
import React, { useState } from "react";
import {
  Container,
  Grid,
  TextField,
  Button,
  Paper,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";

const Register = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle registration logic here
  };

  return (
    <Container maxWidth="xs" sx={{ marginTop: 5 }}>
      <Paper sx={{ padding: 2 }}>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12}>
            <Typography
              variant="h4"
              component="h2"
              sx={{ textAlign: "center" }}
            >
              Register
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    type="email"
                    label="Email"
                    fullWidth
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    type="password"
                    label="Password"
                    fullWidth
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button type="submit" fullWidth variant="contained">
                    Register
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Link to="/login" style={{ textDecoration: "none" }}>
                    <Button fullWidth variant="contained">
                      Log In
                    </Button>
                  </Link>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default Register;
